module.exports = __webpack_public_path__ + "img/weed_pack.ed45919f.png";